export default class GenesysKnowledgeBaseService {
  constructor({ host, accountId }) {
    this.host = host
    this.accountId = accountId

    this.sessionId = null

    this.host = `https://api.${host}`
  }

  setDeploymentId(deploymentId) {
    this.deploymentId = deploymentId
  }

  async createGuestSession(visitorId, pageUrl, appType = 'MessengerKnowledgeApp') {
    if (!this.deploymentId) {
      throw new Error('Deployment ID is not set')
    }

    const url = `${this.host}/api/v2/knowledge/guest/sessions`

    const body = {
      app: {
        type: appType,
        deploymentId: this.deploymentId,
      },
      customerId: visitorId,
      pageUrl: pageUrl,
    }

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      const data = await response.json()
      this.sessionId = data.id
      return data
    } catch (error) {
      console.error('There was a problem with the fetch operation:', error)
      throw error
    }
  }

  async search(query, queryType = 'ManualSearch', pageSize = 100, pageNumber = 1) {
    const url = `${this.host}/api/v2/knowledge/guest/sessions/${this.sessionId}/documents/search`

    const body = {
      query,
      pageSize,
      pageNumber,
      queryType,
    }

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      const data = await response.json()
      return { results: data.results, total: data.total, query: query }
    } catch (error) {
      console.error('There was a problem with the fetch operation:', error)
      throw error
    }
  }

  async getCategories(parentId = null, pageSize = 100, pageNumber = 1) {
    const url = `${this.host}/api/v2/knowledge/guest/sessions/${this.sessionId}/categories?pageSize=${pageSize}&pageNumber=${pageNumber}${parentId ? `&parentId=${parentId}` : ''}`

    try {
      const response = await fetch(url)
      /*
      example response:
      {
    "entities": [
        {
            "id": "fb01e710-b407-49f9-9f27-9092ddefb38f",
            "name": "Getting started",
            "dateCreated": "2024-12-03T09:40:53.551Z",
            "dateModified": "2024-12-03T09:40:53.556Z"
        },
        {
            "id": "81f061e3-ad15-47b9-b9ba-a51ed4711842",
            "name": "TrueEngage APIs",
            "dateCreated": "2024-12-03T09:41:12.279Z",
            "dateModified": "2024-12-03T09:41:12.283Z"
        }
    ],
          "sessionId": "29509b8a-8c25-43bc-b976-b0a8b6ee015d"
      }
      */
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      const data = await response.json()
      return data.entities
    } catch (error) {
      //TODO handle 404 error invalid session (need to create new session)
      console.error('There was a problem with the fetch operation:', error)
      throw error
    }
  }

  async getDocuments(categories = [], pageSize = 100, pageNumber = 1) {
    const categoryIdQueryString = categories.join(',')
    const url = `${this.host}/api/v2/knowledge/guest/sessions/${this.sessionId}/documents?pageSize=${pageSize}&pageNumber=${pageNumber}${categoryIdQueryString ? `&categoryId=${categoryIdQueryString}` : ''}`

    try {
      const response = await fetch(url)
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      const data = await response.json()
      return data.entities
    } catch (error) {
      //TODO handle 404 error invalid session (need to create new session)
      console.error('There was a problem with the fetch operation:', error)
      throw error
    }
  }

  async getDocument(documentId) {
    const url = `${this.host}/api/v2/knowledge/guest/sessions/${this.sessionId}/documents/${documentId}`

    try {
      const response = await fetch(url)
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      const data = await response.json()
      return data
    } catch (error) {
      console.error('There was a problem with the fetch operation:', error)
      throw error
    }
  }

  async suggestions(query, pageSize = 3) {
    const url = `${this.host}/api/v2/knowledge/guest/sessions/${this.sessionId}/documents/search/suggestions`

    const body = {
      query,
      pageSize,
    }

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      const data = await response.json()
      return data.results
    } catch (error) {
      console.error('There was a problem with the fetch operation:', error)
      throw error
    }
  }
}
